/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * 哈萨克
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Для того чтобы уведомить вас, когда ваш предзаказ будет доступен в нашем магазине, а также для подтверждения вашего предзаказа при получении, Xiaomi требуются ваши имя и адрес электронной почты. Код для получения будет отправлен на указанный вами адрес электронной почты.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Правовым основанием для такой обработки ваших персональных данных является необходимость исполнения договора, стороной которого вы являетесь.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        Вы можете реализовать свои права в отношении защиты данных (например, доступ, исправление и/или удаление) через нашу Платформу поддержки конфиденциальности<br>(<a href="https://privacy.mi.com/support/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff"> https://privacy.mi.com/support/</span></a>).
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Пожалуйста, ознакомьтесь с нашей Политикой конфиденциальности <br>(<a href="https://privacy.mi.com/all/languages/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/all/languages/</span></a>)для получения информации о том, как мы обрабатываем ваши персональные данные.</span>
                </p>
                <br>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Сіздің алдын ала тапсырысыңыз біздің дүкенде қолжетімді болған кезде хабарлау үшін, сондай-ақ тапсырысты алған сәтте оны растау үшін Xiaomi сіздің атыңыз бен электрондық пошта мекенжайыңызды талап етеді. Алу коды сіз көрсеткен электрондық пошта мекенжайына жіберіледі.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Сіз тарап болып табылатын шартты орындау мақсатында Xiaomi сіздің жеке деректеріңізді өңдейтін болады. Осы арқылы сіз жеке деректеріңізді жинауға және өңдеуге келісім бересіз.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        Деректерді қорғау құқығыңызды (мысалы, қол жеткізу, түзету және/немесе жою) біздің Құпиялықты қолдау платформасы арқылы жүзеге асыра аласыз: <br><a href="https://privacy.mi.com/support/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff"> https://privacy.mi.com/support/</span></a>.<br>Жеке деректеріңізді қалай өңдейтініміз туралы қосымша ақпарат алу үшін біздің Құпиялық саясатымен мына сілтеме арқылы танысуыңызды сұраймыз: <br><a href="https://privacy.mi.com/all/languages/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/all/languages/</span></a>.
                    </span>
                </p>
            </div>
        </body>
    </html>`;

    
function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)